export const MAX_NUMBER_OF_FILES_MESSAGE = 5;

export const MAX_NUMBER_OF_ADD_DELETE_FILES_MESSAGE = 20;

export const MIME_FILES_ALLOWED = [
  'image/gif',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/x-png',
  'image/pjpeg',
  'image/tiff',
  'image/bmp',
  'text/plain',
  'text/html',
  'text/xml',
  'text/rtf',
  'application/postscript',
  'application/rtf',
  'application/pdf',
  'application/msword',
  'application/octet-stream',
  'application/rtf',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'audio/x-ms-wmv',
  'audio/mpeg',
  'audio/basic',
  'video/mp4',
  'video/x-m4v',
  'video/mpeg',
  'video/quicktime',
  'video/mpeg',
  'video/x-ms-wmv'
];
